var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.07812 9.79058L0.164062 5.44503C0.0546874 5.32286 0 5.16579 0 4.97382C0 4.78185 0.0546874 4.62478 0.164062 4.50262L1.03125 3.56021C1.14063 3.42059 1.27734 3.35079 1.44141 3.35079C1.60547 3.35079 1.75 3.42059 1.875 3.56021L4.5 6.49215L10.125 0.209424C10.25 0.0698082 10.3945 0 10.5586 0C10.7227 0 10.8594 0.0698082 10.9688 0.209424L11.8359 1.15183C11.9453 1.274 12 1.43106 12 1.62304C12 1.81501 11.9453 1.97208 11.8359 2.09424L4.92188 9.79058C4.8125 9.93019 4.67188 10 4.5 10C4.32812 10 4.1875 9.93019 4.07812 9.79058Z",
    fill: "#36B37E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.7ff869076604c0f810a551c97c84ca7d.svg";
export { ForwardRef as ReactComponent };